// messageAPI.js
import { API_CONFIG } from "../../utils/api-config";
import fetchWithAuth from "../../utils/apiAthurization";

/* ------------------------------------
   SEND MESSAGE
------------------------------------ */
export const ChangePassword = async data => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/messaging/password-changes`,
      "POST",
      data
    );
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Password change failed",
      statusCode: error.response?.status || 500
    };
  }
};